import { CommonModule } from '@angular/common';
import {
  AfterViewChecked,
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Optional,
  Output,
  Self,
  ViewChild,
} from '@angular/core';
import {
  FormControl,
  FormsModule,
  NgControl,
  ReactiveFormsModule,
} from '@angular/forms';
import { BaseControlValueAccessor } from '../base-cva';

@Component({
  selector: 'app-input',
  imports: [FormsModule, CommonModule, ReactiveFormsModule],
  templateUrl: './input.component.html',
  styleUrl: './input.component.scss',
})
export class InputComponent
  extends BaseControlValueAccessor<string>
  implements AfterViewChecked
{
  @ViewChild('titleInput') titleInputRef!: ElementRef<HTMLInputElement>;

  @Input() isEditing!: boolean;
  @Output() isEditingChange = new EventEmitter<boolean>();
  @Output() inputValueChange = new EventEmitter<string>();
  @Output() save = new EventEmitter<void>();
  @Input() formControl!: FormControl;
  @Input() inputStyle: any;
  private shouldFocus = true;
  constructor(@Optional() @Self() public override ngControl: NgControl) {
    super(ngControl);
  }

  ngAfterViewChecked(): void {
    if (this.shouldFocus && this.titleInputRef?.nativeElement) {
      this.titleInputRef.nativeElement.focus();
      this.titleInputRef.nativeElement.select();
      this.shouldFocus = false;
    }
  }
  onBlur(): void {
    this.shouldFocus = true;
    this.isEditing = false;
    this.isEditingChange.emit(false);
    this.onTouch(this.value);
    this.save.emit();
  }

  onEnter(): void {
    this.onBlur();
  }

  onEscape(): void {
    this.onBlur();
  }

  onInput(event: Event): void {
    const newValue = (event.target as HTMLInputElement).value;
    this.formControl.setValue(newValue);
    this.titleInputRef.nativeElement.style.width =
      (newValue.length || 1) + 1 + 'ch';
  }
}
